import {IS_PROD, IS_SERVER, IS_TEST} from '@/constants/env'

const log = (title: string, style: string | { [key: string]: any }, info = ''): void => {
    if (IS_PROD || IS_SERVER) {
        return
    }

    if (typeof style === 'string') {
        console.log(`%c${title}`, `color: #fff; background: ${style};`, info)
    }
    else {
        const styleStr = Object
            .entries(style)
            .map(([key, value]) => `${key}: ${value}; `)
            .join('')
        console.log(`%c${title}`, styleStr, info)
    }
}

export const bridgeCallLog = (actionName: string, params: any = '') => {
    log(`【BRIDGE】${actionName}`, '#ee8232', params)
}

export const dataLog = (data: any) => {
    log('【RES】', '#549f56', data)
}

export const errorLog = (data: any) => {
    log('【ERROR】', 'red', data)
}

export const toNativeLog = (scheme: string, params: any) => {
    log(`【SCHEME】${scheme}`, '#ee8232', params)
}

export const haboLog = (name: string, id: number, others: any) => {
    const style = {color: '#d46b08', background: '#fff7e6'}
    log(`【REPORT】${name}:${id}`, style, others)
}

export const importantLog = (info: any) => {
    const style = {
        'font-size': '20px',
        color: '#f00',
        background: 'yellow',
        'border-right': '50vw solid yellow',
        'font-weight': 900,
    }
    const text = typeof info === 'object' ? JSON.stringify(info, null, '\t') : info
    log(text, style)
    // log(`fmp: ${fmp}ms`, style);
}

export default log
